import React, { useEffect, useState } from 'react'
import './Branditems.scss'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../constants/env'
import Tempfooter from '../Tempfooter'

const Branditems = () => {
  const [searchname, setSearchName] = useState("")
  const [branddata, setBrandData] = useState([])
  const [filtData, setFiltData] = useState([])
  const location = useLocation()
  const navigate = useNavigate()
  const searchHandle = (event) => {
    const searchTerm = event.target.value;
    setSearchName(searchTerm.trim());
    if (!searchTerm) {
        setBrandData(filtData); 
        return;
    }
    const filteredItems = filtData.filter((item) =>
      item.name.toLowerCase().startsWith(searchTerm.toLowerCase())
    );
    setBrandData(filteredItems);
  }

  const brandData = async () => {
    try{
      let data = await axios.get(`${Baseurl}/brand`)
      setBrandData(data.data.data)
      setFiltData(data.data.data)
    }catch(error){
      console.log(error.message);  
    }
  }
  const imgHandler = async (id) => {
    await navigate(`/Shop?brands=${id}`)
  }


  useEffect(()=>{
    brandData()
  },[])
  return (


    <div>
          <main className='main'>
          <section className='section-inner-page'>
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12 w-100 text-white text-center bg-theme'>
          <div className='p-5'>
            <p className='fs-1'>Shop By Brand</p>
            <span className='fs-6'> <Link className='text-white' to="/" style={{textDecoration: 'none'}}>HOME</Link></span>
            <span className='ps-1 pe-1'>/</span>
            <span className='fs-6'>SHOP BY BRAND</span>
          </div>
          
        </div>
      </div>
    </div>

    <div className='container mt-sm-5 mt-1'>
      <div className='row'>
        <div className='col-sm-3'>
          <div className=''>
            <input className='form-control' type='text' placeholder='Search for Brand' maxlength="30" value={searchname} onChange={(event) => searchHandle(event)}/>
          </div>
        </div>
      </div>
      

      <div className='row mt-3 pb-5'>
        <div className='col-sm-12'>
          <div className='d-flex gap-3'>
            { branddata.length ? branddata.map((item,index) => {
              return (
                <div key={index} className='border'>
                  <button onClick={() => imgHandler(item._id)}>
                    <figure>
                      <img style={{width:'70px',height:'50px'}} src={`${Baseurl}/view/imageupload/${item?.img}`} />
                    </figure>
                  </button>
                </div>
            )}) : 
            <div className='fs-1 text-center w-100'>
              <p>No Such Brand</p> 
            </div>}
          </div>
        </div>
      </div>
      </div>
      
      </section>
      </main>
      <Tempfooter />

    </div>

  
   
  )
}

export default Branditems
